import { render, staticRenderFns } from "./DeleteCommentConfirmationDialog.vue?vue&type=template&id=0410d011&scoped=true&"
import script from "./DeleteCommentConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteCommentConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410d011",
  null
  
)

export default component.exports